// Tier 3 — one tool, one outcome. Written area by area (TUTORIALS-PLAN.md §9: The table → Prep → Your players → Your data →
// Playing); each file lands with the `data-tour` anchors its steps need, and the `?` on a tool lights up the moment its
// tutorial exists here (ui/tutorial-help.tsx renders nothing for an id the registry lacks).
import { PREP_TOOLS } from "./tier3-prep";
import { DATA_TOOLS, PLAYERS_TOOLS, PLAYING_TOOLS } from "./tier3-rest";
import { TABLE_TOOLS } from "./tier3-table";
import type { Tutorial } from "./types";

// The writing order of TUTORIALS-PLAN.md §9: The table → Prep → Your players → Your data → Playing.
export const TIER3: Tutorial[] = [...TABLE_TOOLS, ...PREP_TOOLS, ...PLAYERS_TOOLS, ...DATA_TOOLS, ...PLAYING_TOOLS];
